<template>
  <div class="integralUser seller-style">
    <!-- <h2 class="f18 fb normal gray_2">积分管理-用户积分</h2> -->
    <div>
      <router-link to="/mj/integral/user"> <el-button type="primary">返回</el-button></router-link>
      <div class="box30"></div>
      <el-table border :data="pointsRecord" row-class-name="pointer">
        <el-table-column show-overflow-tooltip prop="usedPoints" min-width="15%" label="获得/消耗数量">
          <template slot-scope="scope"> {{ scope.row.type === 1 || scope.row.type === 4 ? "+" : "-" }}{{ scope.row.usedPoints }} </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="ptTypeName" label="来源/用途" min-width="15%" />
        <el-table-column prop="createDate" label="时间" min-width="15%" />
      </el-table>
    </div>
    <div class="pad30-t t_right">
      <el-pagination
        popper-class="seller-style"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";

export default {
  data() {
    return {
      pointsRecord: [],
      pageSize: 10, // 商品列表页分页大小
      currentPage: 1, // 商品列表页当前分页
      totalCount: 0, // 商品列表页商品总数
      boId: "",
    };
  },
  created() {
    this.boId = this.$route.query.boId;
    this.getMyPointsRecord();
  },
  mounted() {},
  // 监听器
  filters: {},
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMyPointsRecord();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMyPointsRecord();
    },
    getMyPointsRecord() {
      const params = {
        boId: this.boId,
        systemId: 20,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      this.$store.dispatch("points/points/getMyPointsRecordByShopId", params).then((data) => {
        const newData = data || {};
        this.pointsRecord = newData.list || [];
        this.totalCount = newData.total || 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
